import React from 'react'
import moment from 'moment'
import {Typography, IconButton} from '@mui/material'
import {makeStyles} from '@mui/styles'
import PropTypes from 'prop-types'
import {bodyText, H4HeaderBlack, subBodyText} from '../../../assets/styles/typography'
import {spaceExtraSmall, spaceSmall, spaceLarge} from '../../../assets/styles/spacing'
import {rxrPrimaryColor, rxrRedColor, rxrGreenColor} from '../../../assets/styles/color'
import RXRIcon from '../../RXRIcon'
import {useDispatch, useSelector} from 'react-redux'
import {updateOccupancyAction} from '../../../actions/occupancyActions'
import {PERMISSION_OCCUPANCY_WRITE} from '../../../constants/AppConstants'
import MessageBox from '../../MessageBox'

const useStyles = makeStyles(theme => ({
  rowContainer: {
    display: 'flex',
  },
  H4HeaderBlack: {
    ...H4HeaderBlack,
  },
  colLabel: {
    ...bodyText,
    flex: 3,
  },
  colAmount: {
    ...bodyText,
    flex: 1,
    textAlign: 'right',
  },
  colDate: {
    ...bodyText,
    flex: 1,
    textAlign: 'right',
  },
  chargeAmountRed: {
    color: rxrRedColor,
  },
  chargeAmountGreen: {
    color: rxrGreenColor,
  },
  noteText: {
    ...subBodyText,
    fontStyle: 'italic',
    marginBottom: spaceSmall,
  },
}))

export default function ChargesTable(props) {
  const classes = useStyles()
  const groupPermissions = useSelector(state => state.GroupPermissions.permissionsObject)
  const dispatch = useDispatch()
  const occupancy = useSelector(state => state.Occupancies.occupanciesLookup[props.occupancyId])
  const charges = [...occupancy.ledgerItems || []]
  charges.reverse()

  async function resyncCharges() {
    return await updateOccupancyAction(dispatch, {id: props.occupancyId, mustUpdateLedger: true})
  }

  return (
    <div>
      <Typography className={classes.H4HeaderBlack}>
        Recent Charges
        {groupPermissions[PERMISSION_OCCUPANCY_WRITE] && (
          <IconButton onClick={resyncCharges} style={{marginLeft: spaceExtraSmall}} title="Re-sync ledger">
            <RXRIcon icon={RXRIcon.REFRESH} />
          </IconButton>
        )}
      </Typography>
      {occupancy.mustUpdateLedger ? (
        <MessageBox className={classes.messageContainer} icon={RXRIcon.INFO} color={rxrPrimaryColor}>
          The balance shown in the app is correct, but some recent charges may be missing from this ledger.
          <br />
          Please check back later for an up to date list.
        </MessageBox>
      ) : null}
      <Typography className={classes.noteText}>
        Note - The charges below are part of, but not all of the total Balance seen above.
      </Typography>
      {charges && charges.length > 0 ? (
        <React.Fragment>
          {charges.map(charge => {
            const amountClass = charge.amount < 0 ? classes.chargeAmountGreen : classes.chargeAmountRed
            return (
              <div key={charge.chargeId} className={classes.rowContainer}>
                <Typography className={classes.colLabel}>{charge.label}</Typography>
                <Typography className={`${classes.colAmount} ${amountClass}`}>{`$${charge.amount.toFixed(2)}`}</Typography>
                <Typography className={classes.colDate}>
                  {charge.chargeDate ? moment(charge.chargeDate).format('MM/DD/YYYY') : ''}
                </Typography>
              </div>
            )
          })}
          <Typography className={classes.noteText}>Review older charges directly on Yardi.</Typography>
        </React.Fragment>
      ) : (
        <Typography className={classes.bodyText}>Resident does not currently have any charges</Typography>
      )}
    </div>
  )
}

ChargesTable.propTypes = {
  occupancyId: PropTypes.string.isRequired,
}
